// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.demo-booking-container {
    font-family: 'Comic Sans MS', 'Marker Felt', 'Arial Rounded MT Bold', sans-serif;
    max-width: 900px;
    margin-top: 100px;
    margin-left: 300px;
    /* margin: 0 auto; */
    align-items: center;
    align-content: center;
    padding: 20px;
    background-color: #f9f4ff;
    border-radius: 15px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
  }
  
  .demo-booking-container::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    background: linear-gradient(90deg, #ff9a9e 0%, #fad0c4 50%, #a18cd1 100%);
  }
  
  .demo-booking-header {
    text-align: center;
    margin-bottom: 30px;
    position: relative;
  }
  
  .demo-booking-header h1 {
    color: #6a4c93;
    font-size: 2.5rem;
    margin-bottom: 10px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .demo-booking-header p {
    color: #8a6dae;
    font-size: 1.2rem;
  }
  
  .header-decoration {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 15px;
  }
  
  .decoration-star {
    font-size: 2rem;
    animation: float 3s ease-in-out infinite;
  }
  
  .decoration-star:nth-child(2) {
    animation-delay: 0.5s;
  }
  
  .decoration-star:nth-child(3) {
    animation-delay: 1s;
  }
  
  .demo-booking-form-container {
    display: flex;
    gap: 30px;
    position: relative;
    align-items: center;
    align-content: center;
    /* margin-left: 95px; */
  }
  
  .demo-booking-form {
    flex: 1 1;
    background-color: white;
    padding: 25px;
    border-radius: 12px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    margin-left: 95px;
  }
  
  .form-section {
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 2px dashed #e0c8ff;
  }
  
  .section-title {
    color: #7e57c2;
    font-size: 1.3rem;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .form-group {
    margin-bottom: 18px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 8px;
    color: #5e35b1;
    font-weight: bold;
    font-size: 0.95rem;
  }
  
  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 12px;
    border: 2px solid #d1c4e9;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s;
    background-color: #f5f1ff;
  }
  
  .form-group input:focus,
  .form-group select:focus,
  .form-group textarea:focus {
    border-color: #7e57c2;
    outline: none;
    box-shadow: 0 0 0 3px rgba(126, 87, 194, 0.2);
  }
  
  .form-group textarea {
    resize: vertical;
    min-height: 80px;
  }
  
  .form-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 20px 0;
  }
  
  .form-checkbox input {
    width: 18px;
    height: 18px;
    accent-color: #7e57c2;
  }
  
  .form-checkbox label {
    color: #5e35b1;
  font-size: 0.95rem;
  /* margin: 0; */
  }

  /* Time Slot Checkboxes */
.time-slot-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.time-slot-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.time-slot-option input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #7e57c2;
}

.time-slot-option label {
  color: #5e35b1;
  font-size: 0.95rem;
  cursor: pointer;
}

/* Hint text for phone inputs */
.hint-text {
  display: block;
  margin-top: 4px;
  color: #666;
  font-size: 0.8rem;
  font-style: italic;
}

  /* .form-checkbox-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 40px;
  } */
  
  .submit-button {
    width: 100%;
    padding: 15px;
    background: linear-gradient(135deg, #7e57c2, #5e35b1);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  #subscribe {
     margin-top: 10px;
  }
  
  .submit-button:hover {
    background: linear-gradient(135deg, #9575cd, #7e57c2);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(94, 53, 177, 0.3);
  }
  
  .form-decoration {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    width: 80px;
  }
  
  .decoration-item {
    font-size: 2.5rem;
    animation: bounce 2s ease infinite;
  }
  
  .crayon {
    color: #ff6b6b;
    animation-delay: 0.2s;
  }
  
  .robot {
    color: #4dabf7;
    animation-delay: 0.4s;
  }
  
  .book {
    color: #69db7c;
    animation-delay: 0.6s;
  }
  
  .demo-booking-footer {
    text-align: center;
    margin-top: 30px;
    color: #8a6dae;
    font-size: 1.1rem;
    font-weight: bold;
  }
  
  .footer-decoration {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 15px;
  }
  
  .footer-decoration span {
    font-size: 1.8rem;
    display: inline-block;
    animation: spin 4s linear infinite;
  }
  
  /* Animations */
  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
  
  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-15px);
    }
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .demo-booking-form-container {
      flex-direction: column;
    }
    
    .form-decoration {
      flex-direction: row;
      width: 100%;
      margin-top: 20px;
    }
    
    .demo-booking-header h1 {
      font-size: 2rem;
    }
  }

.email-verification-container {
  display: flex;
  gap: 10px;
  /* align-items: center; */
}

.email-verification-container input {
  flex: 1 1;
}

.send-otp-button {
  padding: 12px 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.3s;
  margin-top: 0;
  height: 100%;
}

.send-otp-button:hover {
  background-color: #45a049;
}

.send-otp-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.otp-input-container {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  align-items: center;
}

.otp-input {
  width: 100px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  text-align: center;
  letter-spacing: 4px;
}

.verify-otp-button {
  padding: 8px 16px;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top:0;
}

.verify-otp-button:hover {
  background-color: #1976D2;
}

.verify-otp-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.success-text {
  color: #4CAF50;
  font-size: 14px;
  margin-top: 5px;
  display: block;
}

input.verified {
  border-color: #4CAF50;
  background-color: #f8fff8;
}

.submit-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.disabled-field {
  background-color: #f5f5f5 !important;
  border-color: #ddd !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

.disabled-label {
  color: #999 !important;
  cursor: not-allowed !important;
}

.hint-text {
  display: block;
  margin-top: 4px;
  color: #666;
  font-size: 0.8rem;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/ChatBot/DemoBookingPage.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,gFAAgF;IAChF,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,yEAAyE;EAC3E;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,iCAAiC;EACnC;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;;IAGE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;;;IAGE,qBAAqB;IACrB,aAAa;IACb,6CAA6C;EAC/C;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB,kBAAkB;EAClB,eAAe;EACf;;EAEA,yBAAyB;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;EAEE;;;;;KAKG;;EAEH;IACE,WAAW;IACX,aAAa;IACb,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;KACG,gBAAgB;EACnB;;EAEA;IACE,qDAAqD;IACrD,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA,eAAe;EACf;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,mBAAmB;MACnB,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;EACF;;AAEF;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Base Styles */\n.demo-booking-container {\n    font-family: 'Comic Sans MS', 'Marker Felt', 'Arial Rounded MT Bold', sans-serif;\n    max-width: 900px;\n    margin-top: 100px;\n    margin-left: 300px;\n    /* margin: 0 auto; */\n    align-items: center;\n    align-content: center;\n    padding: 20px;\n    background-color: #f9f4ff;\n    border-radius: 15px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .demo-booking-container::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 10px;\n    background: linear-gradient(90deg, #ff9a9e 0%, #fad0c4 50%, #a18cd1 100%);\n  }\n  \n  .demo-booking-header {\n    text-align: center;\n    margin-bottom: 30px;\n    position: relative;\n  }\n  \n  .demo-booking-header h1 {\n    color: #6a4c93;\n    font-size: 2.5rem;\n    margin-bottom: 10px;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .demo-booking-header p {\n    color: #8a6dae;\n    font-size: 1.2rem;\n  }\n  \n  .header-decoration {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 15px;\n  }\n  \n  .decoration-star {\n    font-size: 2rem;\n    animation: float 3s ease-in-out infinite;\n  }\n  \n  .decoration-star:nth-child(2) {\n    animation-delay: 0.5s;\n  }\n  \n  .decoration-star:nth-child(3) {\n    animation-delay: 1s;\n  }\n  \n  .demo-booking-form-container {\n    display: flex;\n    gap: 30px;\n    position: relative;\n    align-items: center;\n    align-content: center;\n    /* margin-left: 95px; */\n  }\n  \n  .demo-booking-form {\n    flex: 1;\n    background-color: white;\n    padding: 25px;\n    border-radius: 12px;\n    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);\n    margin-left: 95px;\n  }\n  \n  .form-section {\n    margin-bottom: 25px;\n    padding-bottom: 20px;\n    border-bottom: 2px dashed #e0c8ff;\n  }\n  \n  .section-title {\n    color: #7e57c2;\n    font-size: 1.3rem;\n    margin-bottom: 15px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .form-group {\n    margin-bottom: 18px;\n  }\n  \n  .form-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #5e35b1;\n    font-weight: bold;\n    font-size: 0.95rem;\n  }\n  \n  .form-group input,\n  .form-group select,\n  .form-group textarea {\n    width: 100%;\n    padding: 12px;\n    border: 2px solid #d1c4e9;\n    border-radius: 8px;\n    font-size: 1rem;\n    transition: all 0.3s;\n    background-color: #f5f1ff;\n  }\n  \n  .form-group input:focus,\n  .form-group select:focus,\n  .form-group textarea:focus {\n    border-color: #7e57c2;\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(126, 87, 194, 0.2);\n  }\n  \n  .form-group textarea {\n    resize: vertical;\n    min-height: 80px;\n  }\n  \n  .form-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin: 20px 0;\n  }\n  \n  .form-checkbox input {\n    width: 18px;\n    height: 18px;\n    accent-color: #7e57c2;\n  }\n  \n  .form-checkbox label {\n    color: #5e35b1;\n  font-size: 0.95rem;\n  /* margin: 0; */\n  }\n\n  /* Time Slot Checkboxes */\n.time-slot-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.time-slot-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.time-slot-option input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #7e57c2;\n}\n\n.time-slot-option label {\n  color: #5e35b1;\n  font-size: 0.95rem;\n  cursor: pointer;\n}\n\n/* Hint text for phone inputs */\n.hint-text {\n  display: block;\n  margin-top: 4px;\n  color: #666;\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n  /* .form-checkbox-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 40px;\n  } */\n  \n  .submit-button {\n    width: 100%;\n    padding: 15px;\n    background: linear-gradient(135deg, #7e57c2, #5e35b1);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 1.1rem;\n    font-weight: bold;\n    cursor: pointer;\n    transition: all 0.3s;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n\n  #subscribe {\n     margin-top: 10px;\n  }\n  \n  .submit-button:hover {\n    background: linear-gradient(135deg, #9575cd, #7e57c2);\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(94, 53, 177, 0.3);\n  }\n  \n  .form-decoration {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 15px;\n    width: 80px;\n  }\n  \n  .decoration-item {\n    font-size: 2.5rem;\n    animation: bounce 2s ease infinite;\n  }\n  \n  .crayon {\n    color: #ff6b6b;\n    animation-delay: 0.2s;\n  }\n  \n  .robot {\n    color: #4dabf7;\n    animation-delay: 0.4s;\n  }\n  \n  .book {\n    color: #69db7c;\n    animation-delay: 0.6s;\n  }\n  \n  .demo-booking-footer {\n    text-align: center;\n    margin-top: 30px;\n    color: #8a6dae;\n    font-size: 1.1rem;\n    font-weight: bold;\n  }\n  \n  .footer-decoration {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-top: 15px;\n  }\n  \n  .footer-decoration span {\n    font-size: 1.8rem;\n    display: inline-block;\n    animation: spin 4s linear infinite;\n  }\n  \n  /* Animations */\n  @keyframes float {\n    0%, 100% {\n      transform: translateY(0);\n    }\n    50% {\n      transform: translateY(-10px);\n    }\n  }\n  \n  @keyframes bounce {\n    0%, 100% {\n      transform: translateY(0);\n    }\n    50% {\n      transform: translateY(-15px);\n    }\n  }\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .demo-booking-form-container {\n      flex-direction: column;\n    }\n    \n    .form-decoration {\n      flex-direction: row;\n      width: 100%;\n      margin-top: 20px;\n    }\n    \n    .demo-booking-header h1 {\n      font-size: 2rem;\n    }\n  }\n\n.email-verification-container {\n  display: flex;\n  gap: 10px;\n  /* align-items: center; */\n}\n\n.email-verification-container input {\n  flex: 1;\n}\n\n.send-otp-button {\n  padding: 12px 16px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.3s;\n  margin-top: 0;\n  height: 100%;\n}\n\n.send-otp-button:hover {\n  background-color: #45a049;\n}\n\n.send-otp-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.otp-input-container {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n  align-items: center;\n}\n\n.otp-input {\n  width: 100px;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  text-align: center;\n  letter-spacing: 4px;\n}\n\n.verify-otp-button {\n  padding: 8px 16px;\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  margin-top:0;\n}\n\n.verify-otp-button:hover {\n  background-color: #1976D2;\n}\n\n.verify-otp-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.success-text {\n  color: #4CAF50;\n  font-size: 14px;\n  margin-top: 5px;\n  display: block;\n}\n\ninput.verified {\n  border-color: #4CAF50;\n  background-color: #f8fff8;\n}\n\n.submit-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.disabled-field {\n  background-color: #f5f5f5 !important;\n  border-color: #ddd !important;\n  cursor: not-allowed !important;\n  opacity: 0.7;\n}\n\n.disabled-label {\n  color: #999 !important;\n  cursor: not-allowed !important;\n}\n\n.hint-text {\n  display: block;\n  margin-top: 4px;\n  color: #666;\n  font-size: 0.8rem;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
